module.exports = __webpack_public_path__ + "static/zama-2-9474228a64bf43c737190d921f2388a4.gif";